var window=global;var $CLJS=require("./cljs_env.js");require("./cljs.core.js");require("./cljs.tools.reader.impl.utils.js");
'use strict';$CLJS.tF=new $CLJS.N(null,"source","source",-433931539);